import { dateConverter } from "./dateConveter";
import { convertToIndianFormat } from "./functions";

export const getInvesterSectionFields = (propertyData, investorSection) => {
  let fields;

  if (investorSection === "assetDetails") {
    fields = propertyData?.assetClass?.fields?.filter(
      field =>
        field.investorSectionKey === investorSection &&
        field.name !== "description" &&
        field.type !== "fileupload" &&
        field.type !== "image"&&
        field.type !== "toggle"
    );
  }else if (investorSection === "transactionDetails") {
    fields = propertyData?.assetClass?.fields?.filter(
      field =>
        field.investorSectionKey === investorSection &&
        field.name !== "minInvestmentAmount" 
    );
  }
   else {
    fields = propertyData?.assetClass?.fields?.filter(
      field =>
        field.investorSectionKey === investorSection &&
        field.type !== "fileupload" &&
        field.type !== "image"
    );
  }

  if (!fields?.length) return [];

  return fields.map(field => {
    let value;

    // Get custom value from customDetails (last match)
    const matchingCustom = [...(propertyData?.customDetails || [])]
      .reverse()
      .find(obj => Object.prototype.hasOwnProperty.call(obj, field.name));
    const customValue = matchingCustom?.[field.name]?.[field.name];
   
    const rawValue =
      propertyData?.[investorSection]?.[field.name] ??
      propertyData?.transactionDetails?.[field.name] ??
      propertyData?.basicInfo?.[field.name] ??
      propertyData?.legal?.[field.name] ??
      propertyData?.transactionDetails?.[field.name] ??
      propertyData?.[field.name] ??
      propertyData?.customDetails?.find(detail =>
        Object.values(detail)?.some(section =>
          section?.[field.name] !== undefined
        )
      )?.[Object.keys(propertyData.customDetails.find(detail =>
        Object.values(detail)?.some(section =>
          section?.[field.name] !== undefined
        )
      ))[0]]?.[field.name]??
      customValue;


    // Format based on type
    if (field.type === "date") {
      value = rawValue
        ? dateConverter({ value: rawValue, momentIsTrue: false, dateFormat: "Do MMM YYYY" })
        : "-";
    }
    // else if (field.type === "number") {
    //   value = convertToIndianFormat(rawValue || 0);
    // }
    else if (field.type === "inr") {
      value = convertToIndianFormat(rawValue || 0);
    } else if (field.type === "percentage") {
      value = `${rawValue}%`;
    } else if (Array.isArray(rawValue)) {
      value = rawValue.join(", ");
    } else if (typeof rawValue === "object" && rawValue !== null) {
      value = JSON.stringify(rawValue);
    } else {
      value = rawValue ?? "-";
    }

    return {
      title: field.unitOfMeasurement
        ? `${field.label} (${field.unitOfMeasurement})`
        : field.label,
      value,
      type: field.type
    };
  });
};
